// src/components/maintenance/MaintenanceUnreachable.jsx
//
// Distinct screen shown when the backend cannot be reached (network error or
// 5xx on /maintenance/status). Deliberately different from "Genius at work.."
// so the cause is obvious. The gate auto-retries every 5s and swaps this out
// once the backend answers.

import React from "react";
import "./MaintenancePage.css";

export default function MaintenanceUnreachable() {
  return (
    <div className="maint-root">
      <div className="maint-bg-cycle" />
      <div className="maint-center">
        <div className="maint-unreachable">
          <h1 className="maint-title">Just a moment…</h1>
          <p className="maint-subtext">
            We can&apos;t reach the server right now. Trying again automatically.
          </p>
        </div>
      </div>
    </div>
  );
}
